const Select = ({ id, name, value, handleChange, data ,height = 58}) => {
  return (
    <>
      <select
        name={name}
        value={value}
        id={id}
        onChange={handleChange}
        className="input-blue w-100   border bg-white p-1 rounded"
        style={{ height: `${height}px` }}
      >
        {data.map((option, index) => (
          <option value={option.value || option.id} key={index} className="fw-light">
            {option.title || option.name}
          </option>
        ))}
      </select>
    </>
  );
};

export default Select;
